import React from 'react';
import ReporteContenedoresBase from './ReporteContenedoresBase.jsx';

/**
 * V1: `IbuFront/src/components/views/Reportes/ReporteContenedores.jsx`.
 * Fuente: TODOS los contenedores del rango de fechas (`GET
 * /contenedores/fechas/:inicio/:fin`, endpoint que ya existía en V2 —
 * `contenedores.service.js#listarPorFechas`, espejo exacto de
 * `ContenedoresController.findOneFechas` de V1).
 */
export default function ReporteContenedoresPage() {
  return <ReporteContenedoresBase endpoint="/contenedores/fechas" title="Reporte Contenedores" permiso="contenedores:reporte" />;
}
